<div id="no-category" fxLayout="column" fxLayoutAlign="center center">

  <div class="content" fxLayout="column" fxLayoutAlign="center center" >
    <img alt="šipka" class="arrow" src="assets/images/signs/arrow_sign.png" @rotate/>
    <div class="message" [@animate]="{value:'*',params:{delay: '300ms', y:'-100%', duration: '400ms'}}">K náhlednutí této stránky potřebujete mít zvolenou kategorii v horní liště</div>
    <img alt="logo echopix cms" class="logo-small" src="assets/images/logos/echopix_cms_logo_rect.svg" [@animate]="{value:'*',params:{delay: '300ms', y:'-100%', duration: '400ms'}}"/>
  </div>
</div>
